export default __webpack_public_path__ + "static/media/womenCover.18aa1f69.svg";